export default __webpack_public_path__ + "static/media/streamlinehq.d828116c.png";